import Aion from '@adoratorio/aion';

const engine = new Aion();

export default engine;
